import { Skeleton } from "antd";
import { Await } from "react-router";
import React from "react";

export default function ({ promise, content }) {
  return (
    <React.Suspense
      fallback={<Skeleton.Input style={{ height: 17, width: 20 }} size={"small"} active loading />}
    >
      <Await resolve={promise}>{(value) => content(value)}</Await>
    </React.Suspense>
  );
}
